import { ReferenceDataDto } from '../../../../generated/auth/models/Sasfin/Dynamics/Api/Client/Models/DTO/reference-data-dto';

export interface IIdTypeState {
  list: ReferenceDataDto[];
  isLoading: boolean;
}

export const initialUIState = {
  // list: [],
  isLoading: false,
};
